import React, { useState } from 'react';
import { MdRefresh } from 'react-icons/md';
import { useStateContext } from '../contexts/ContextProvider';

const Header = ({ category, title, refresh }) => {
	const { currentColor } = useStateContext();
	const [isRefreshing, setIsRefreshing] = useState(false);

	const handleRefresh = () => {
		setIsRefreshing(true);
		if (refresh) refresh();
		setTimeout(() => setIsRefreshing(false), 1000);
	};

	return (
		<div className='mb-10 relative'>
			{/* Effet de fond décoratif */}
			<div className='absolute -left-4 top-0 w-1 h-full rounded-full opacity-70 animate-pulse'
				style={{ background: currentColor }}
			/>

			{/* Contenu principal */}
			<div className='flex items-center justify-between'>
				<div className='space-y-1'>
					{/* Catégorie avec animation au survol */}
					<div className='text-sm font-medium text-gray-500 uppercase tracking-wider 
						transition-all duration-300 hover:tracking-widest hover:text-gray-600'>
						{category}
					</div>

					{/* Titre avec gradient et animation */}
					<div className='flex items-center gap-3'>
						<h1 className='text-4xl font-black tracking-tight bg-gradient-to-r from-slate-900 via-slate-700 to-slate-900 
							bg-clip-text text-transparent animate-gradient bg-300%'>
							{title}
						</h1>

					</div>

				</div>

				{/* Bouton refresh amélioré */}
				{refresh && (
					<button
						onClick={handleRefresh}
						type='button'
						className='group relative p-3 rounded-2xl text-white shadow-lg 
							transform transition-all duration-300 hover:scale-110 hover:rotate-12 
							hover:shadow-2xl active:scale-95'
						style={{ background: currentColor }}
					>
						<MdRefresh
							className={`text-2xl transition-transform duration-700 ${isRefreshing ? 'rotate-[360deg]' : ''
								} group-hover:rotate-180`}
						/>

						{/* Effet de brillance au survol */}
						<div className='absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 
							transition-opacity duration-300 bg-gradient-to-tr from-transparent 
							via-white to-transparent bg-300% animate-shimmer'
							style={{ mixBlendMode: 'overlay' }}
						/>
					</button>
				)}
			</div>

			{/* Style pour les animations personnalisées */}
			<style jsx>{`
				@keyframes gradient {
					0%, 100% { background-position: 0% 50%; }
					50% { background-position: 100% 50%; }
				}
				@keyframes shimmer {
					0% { background-position: -200% center; }
					100% { background-position: 200% center; }
				}
				.animate-gradient {
					animation: gradient 3s ease infinite;
				}
				.animate-shimmer {
					animation: shimmer 2s ease-in-out infinite;
				}
				.bg-300\\% {
					background-size: 300% 300%;
				}
			`}</style>
		</div>
	);
};

export default Header;